import { usePageState } from './usePageState';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { routerState } from 'states/atoms/routerState';
import { SpeedTestStatus } from 'types/NetworkScan/SpeedTestStatus';

export const useRouterScan = () => {
  const { setRouterState } = usePageState();
  const [routerScan, setRouterScan] = useRecoilState(routerState);
  const resetState = useResetRecoilState(routerState);

  return {
    startScan: () => {
      setTimeout(() => {
        setRouterState({
          downloadSpeed: '99',
        });
        setRouterScan((rscan) => ({
          ...rscan,
          scanState: SpeedTestStatus.completed,
        }));
      }, 3000);

      return;
    },
    scanState: routerScan.scanState,
    cancelScan: () => {
      resetState();
      setRouterState(null);
    },
  };
};
